import { GridColDef } from "@mui/x-data-grid-pro";

import ItemStatus from "../../../../../../common/components/item_status";
import dayjs from "dayjs";

export const GenerateTreinamentosColumnsDefinition = (): GridColDef[] => {
  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 1: return "A";
      case 2: return "D";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 1: return "red";
      case 2: return "blue";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 1: return "Avaliação em atraso";
      case 2: return "Avaliação dentro do prazo";
      default:
        return "?";
    }
  };

  return [
    {
      field: "status",
      filterable: false,
      headerName: "Status",
      width: 90, 
      sortable: false,
      align: 'center',
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)} />
        </div>
      )
    },
    {
      field: "funcionario",
      filterable: false,
      headerName: "Funcionário",
      flex: 1, 
      minWidth: 200, 
      sortable: false,
      align: 'left',
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "cargo",
      filterable: false,
      headerName: "Cargo",
      flex: 1,
      minWidth: 150, 
      sortable: false,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "centroCusto",
      filterable: false,
      headerName: "Centro de Custo",
      flex: 1,
      minWidth: 150, 
      sortable: false,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "treinamento",
      filterable: false,
      headerName: "Treinamento",
      flex: 1,
      minWidth: 150, 
      sortable: false,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "instrutor",
      filterable: false,
      headerName: "Instrutor",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "dataInicio",
      filterable: false,
      headerName: "Data",
      width: 110,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">{params.value && dayjs(params.value).format("DD/MM/YYYY")}</div>
      ),
    },
    {
      field: "dataPrevAvaliacao",
      filterable: false,
      headerName: "Data Prev. Avaliação",
      width: 160, 
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">{params.value && dayjs(params.value).format("DD/MM/YYYY")}</div>
      ),
    },
  ];
}
